import { Star, ArrowUpRight, PenLine } from "lucide-react";
import { MAP_URL, GOOGLE_RATING, GOOGLE_REVIEW_COUNT } from "@/lib/site";
import { Reveal } from "./Reveal";

const Stars = ({ value }) => (
  <div className="flex gap-1" aria-label={`5 üzerinden ${value}`}>
    {[1, 2, 3, 4, 5].map((n) => (
      <span key={n} className="relative h-7 w-7 md:h-9 md:w-9">
        <Star className="absolute inset-0 h-full w-full text-white/20" fill="currentColor" strokeWidth={0} />
        <span className="absolute inset-0 overflow-hidden" style={{ width: `${Math.min(1, Math.max(0, value - n + 1)) * 100}%` }}>
          <Star className="h-7 w-7 text-[#FBBC04] md:h-9 md:w-9" fill="currentColor" strokeWidth={0} />
        </span>
      </span>
    ))}
  </div>
);

export const GoogleReviews = () => (
  <section data-testid="google-reviews-section" className="border-b border-white/10 bg-surface">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-5 py-20 md:px-8 lg:grid-cols-[auto_1fr_auto] lg:gap-16">
      <Reveal className="flex items-end gap-5">
        <p data-testid="google-rating" className="font-display text-[7rem] leading-[0.8] text-white md:text-[9rem]">{GOOGLE_RATING.toLocaleString("tr-TR")}</p>
        <div className="pb-2">
          <Stars value={GOOGLE_RATING} />
          <p data-testid="google-review-count" className="mt-3 text-sm font-semibold uppercase tracking-[0.2em] text-neutral-300">{GOOGLE_REVIEW_COUNT} Google yorumu</p>
        </div>
      </Reveal>
      <Reveal delay={0.08}>
        <p className="mb-3 flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.25em] text-neutral-400"><span className="h-[2px] w-8 bg-brand" />Google Haritalar</p>
        <h2 className="font-display text-4xl uppercase leading-none text-white md:text-6xl">Parkura gelenler anlatıyor.</h2>
        <p className="mt-4 max-w-xl text-neutral-400">FX Motor Sporları'nın Google Haritalar'daki puanı. Yorumların tamamını Google'da okuyabilir, siz de deneyiminizi paylaşabilirsiniz.</p>
      </Reveal>
      <Reveal delay={0.16} className="flex flex-col gap-3 sm:flex-row lg:flex-col">
        <a href={MAP_URL} target="_blank" rel="noopener noreferrer" data-testid="google-reviews-read-btn" className="group flex items-center justify-center gap-3 bg-white px-7 py-4 font-bold uppercase tracking-wider text-black transition-colors hover:bg-brand hover:text-white">
          Yorumları oku <ArrowUpRight className="h-5 w-5 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
        </a>
        <a href={MAP_URL} target="_blank" rel="noopener noreferrer" data-testid="google-reviews-write-btn" className="flex items-center justify-center gap-3 border border-white/25 px-7 py-4 font-bold uppercase tracking-wider text-white transition-colors hover:border-white">
          <PenLine className="h-5 w-5" /> Yorum yaz
        </a>
      </Reveal>
    </div>
  </section>
);
